/** */
import {DiffPanelBase} from "back/edit/wed/features/diffBar_";
import {OtherItemDiffAction} from "back/wsp/widgets/wed/itemEditorExt";
import {IWedDiffBar} from "back/edit/wed/features/diffBar";
import {REG} from "lib/commons/registry";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {EXmlDiffMode} from "lib/edit/schema/diff";
import {JSX} from "lib/commons/xml/dom";
import "back/wsp/widgets/widgets_Perms";
import {callDiff} from "back/wsp/widgets/wed/wspDiffBar";
import {JGitHeadWedDiffBarParams} from "back/wsp/areas/gitOverrides";
import {EGitState, JGitSrcFields, WSP_GIT} from "lib/wsp/git";


/**
 *
 */
export class GitHeadDiffPanel extends DiffPanelBase<IItemUiEnv> {

	erased?: boolean

	initPanel(action: OtherItemDiffAction, bar: IWedDiffBar): this {
		this._initPanel(action, bar);
		this.shadowRoot.appendChild(this.result);
		this.execDiff();
		return this;
	}

	setDiff(params: JGitHeadWedDiffBarParams | undefined | null): void {
		this.erased = params === null;
		this.execDiff();
	}

	buildDiffParams(): JGitHeadWedDiffBarParams {
		return {diffId: this.action.getId()}
	}

	async execDiff(fullRefresh?: boolean): Promise<void> {
		if (fullRefresh) this.erased = false;
		if(this.erased) return callDiff("", this, EXmlDiffMode.diff);
		const gitSt = (this.reg.env.longDesc as JGitSrcFields).gitSt;
		if(gitSt === EGitState.insynch || WSP_GIT.match(gitSt, EGitState.changed) || WSP_GIT.match(gitSt, EGitState.modified)) {
			return callDiff("special:git:head", this, EXmlDiffMode.diff);
		}
		this.wedMgr.docHolder.setDiffSession(null);
		this.updateDiffResult("notFound");
	}
}

REG.reg.registerSkin("wed-diff-githead", 1, /* language=CSS */ `
	:host {
		display: flex;
		justify-content: center;
	}
`);

customElements.define("wed-diff-githead", GitHeadDiffPanel);